(function () {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const moneyEUR = (cents) => (cents / 100).toFixed(2).replace(".", ",") + "€";

  // Debounce per evitare troppe chiamate
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  async function fetchCartTotal() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) return null;
    const cart = await res.json();
    return cart && typeof cart.total_price === "number" ? cart.total_price : null;
  }

  function updateOne(widget, totalCents) {
    const threshold = parseInt(widget.dataset.freeThresholdCents || "4000", 10);
    const total =
      Number.isFinite(totalCents) ? totalCents : parseInt(widget.dataset.cartTotalCents || "0", 10);

    const percent = clamp(Math.floor((total * 100) / threshold), 0, 100);
    const remaining = Math.max(0, threshold - total);
    const isFree = total >= threshold;

    const fill = widget.querySelector(".fsp__fill");
    const knob = widget.querySelector(".fsp__knob");
    const text = widget.querySelector(".fsp__text");
    const bar = widget.querySelector(".fsp__bar");

    if (fill) fill.style.width = percent + "%";
    if (knob) knob.style.left = percent + "%";
    if (bar) bar.setAttribute("aria-valuenow", String(percent));

    // Evidenzia percentuali raggiunte (0/25/50/75/100)
    const steps = widget.querySelectorAll(".fsp__scale [data-step]");
    steps.forEach((el) => {
      const step = parseInt(el.dataset.step || "0", 10);
      el.classList.toggle("is-reached", percent >= step);
    });

    // Testo su 2 righe
    if (text) {
      let line1 = "";
      let line2 = "";

      if (isFree) {
        line1 = "🚚 Spedizione gratuita sbloccata!";
        line2 = "Ottima scelta.";
      } else {
        if (percent < 30) line1 = "Inizia alla grande 💨";
        else if (percent < 60) line1 = "Ci sei quasi 🔥";
        else if (percent < 90) line1 = "Dai che manca poco 😏";
        else line1 = "Ultimo passo 🚀";

        line2 = `Ti mancano <strong>${moneyEUR(remaining)}</strong> per la spedizione gratuita`;
      }

      text.innerHTML =
        `<span class="fsp__line1">${line1}</span>` +
        `<span class="fsp__line2">${line2}</span>`;
    }
  }

  function updateAll(totalCents) {
    document.querySelectorAll(".fsp").forEach((w) => updateOne(w, totalCents));
  }

  const refreshFromServer = debounce(async () => {
    const total = await fetchCartTotal();
    if (total != null) updateAll(total);
  }, 250);

  // 1) Prima render: totale vero
  document.addEventListener("DOMContentLoaded", () => {
    refreshFromServer();
  });

  // 2) Click su + / - / rimuovi (Dawn)
  document.addEventListener("click", (e) => {
    const t = e.target;
    if (!t) return;

    const qtyBtn = t.closest && t.closest(".quantity__button");
    const removeBtn = t.closest && (t.closest("cart-remove-button") || t.closest(".cart-remove"));

    if (qtyBtn || removeBtn) {
      // Dawn aggiorna via ajax: aspettiamo un attimo e poi leggiamo /cart.js
      refreshFromServer();
    }
  });

  // 3) Change/input quantità
  document.addEventListener("change", (e) => {
    const t = e.target;
    if (t && t.matches && (t.matches(".quantity__input") || t.matches("input[name='updates[]']"))) {
      refreshFromServer();
    }
  });
  document.addEventListener("input", (e) => {
    const t = e.target;
    if (t && t.matches && (t.matches(".quantity__input") || t.matches("input[name='updates[]']"))) {
      refreshFromServer();
    }
  });

  // 4) Evento Dawn (se presente)
  document.addEventListener("cart:refresh", () => {
    refreshFromServer();
  });

  // 5) MutationObserver: se Dawn cambia il DOM del carrello, aggiorna
  function attachObserver() {
    const cartRoot =
      document.querySelector("cart-items") ||
      document.querySelector("#MainContent") ||
      document.querySelector("main");

    if (!cartRoot) return;

    const obs = new MutationObserver(() => {
      refreshFromServer();
    });

    obs.observe(cartRoot, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", attachObserver);
  document.addEventListener("shopify:section:load", () => {
    refreshFromServer();
    attachObserver();
  });
})();